import { ACTION } from "./constant";
import isEmpty from "lodash/isEmpty";
 
export default function seeAll(state = {}, action) {
    switch (action.type) {
        case ACTION.SEE_ALL_CONTENT:
            //action.isLoadMore means if this is false then do not add content list with revious one(becuse live channels)
            // add below code for seeall content list need to update latest content list in "seeAllResult" to shoe the all content on see all page
            const newContentList = action.isLoadMore && !isEmpty(state.seeAllResult)
                ? [...state.contentList, ...action.apiResponse.data.contentList]
                : action.apiResponse.data.contentList;
 
            const newSeeAllResult = {
                ...action.apiResponse.data,
                ...(newContentList.length > 1 && { contentList: newContentList })
            };
            return {
                ...state,
                // seeAllResult: action.apiResponse.data,
                seeAllResult: newSeeAllResult,
                // contentList: !isEmpty(state.seeAllResult) ? [...state.contentList, ...action.apiResponse.data.contentList] : action.apiResponse.data.contentList,
                contentList: newContentList,
                exactCount: action.isLoadMore && !isEmpty(state.seeAllResult) ?
                    state.exactCount + action.apiResponse.data.exactCount : action.apiResponse.data.exactCount,
                updatedCount:  action.isLoadMore && !isEmpty(state.seeAllResult) ?
                    state.updatedCount + action.apiResponse.data.updatedCount : action.apiResponse.data.updatedCount,
            };
        // for load the genre filter data
        case ACTION.SEE_ALL_GENRA:
            return {
                ...state,
                seeAllResultGenre: action.apiResponse.data,
            };
        case ACTION.CLEAR_CONTENT:
            return {};
        default:
            return state;
    }
}